module.exports = __webpack_public_path__ + "static/img/share.2dbd8c85.png";